
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { userSelector } from "slices/userSlice";
import { usePermissions } from "layouts/Admin";
import { paymentStatementSelector } from "slices/paymentStatementSlice";
import { fetchPaymentStatements } from "slices/paymentStatementSlice";
import Api from "services/api";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { markPaymentAsPaid } from "slices/paymentStatementSlice";

function IntepreterPaymentsStatement() {
    const dispatch = useDispatch()
    const { checkPermission } = usePermissions();
    const [filters, setFilters] = useState({});
    const { paymentStatements: payment, generatedInvoices, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(paymentStatementSelector);

    const [statusModal, setStatusModal] = React.useState(false);

    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'name',
        sortDirection: 'asc',
    });
    const [downloadLoader, setDownloadLoader] = useState(false);
    const { user } = useSelector(userSelector);
    const userToken = user.token;

    React.useEffect(() => {
        dispatch(fetchPaymentStatements(1))
    }, [])

    const [paymentStatementLoader, setPaymentStatementLoader] = useState(false);
    const DownloadCsv = async (id) => {
        setPaymentStatementLoader(true);
        try {

            setDownloadLoader(true);
            // Get Blob from backend
            const response = await Api.downloadInterpreterPaymentsStatementCsv(id);

            // Convert response data to Blob
            const blob = new Blob([response.data], {
                type: 'text/csv', // ya 'application/octet-stream'
            });

            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = 'interpreter-payments.xlsx';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Download error:', error);
            toast.error('Download failed');
        } finally {
            setPaymentStatementLoader(false);
        }
    };
    const DownloadAttachedFile = async (id) => {
        setPaymentStatementLoader(true);
        try {

            setDownloadLoader(true);
            const response = await Api.downloadInterpreterPaymentsStatementAttachedFile(id);
  
            const contentType =
            response.headers['content-type'] ||
            'application/octet-stream';

            const blob = new Blob([response.data], {
                type: contentType,
            });

            const url = window.URL.createObjectURL(blob);

            const contentDisposition =
            response.headers['content-disposition'];

            let fileName = 'download';

            if (contentDisposition) {
                const fileNameMatch =
                    contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
  
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = fileNameMatch[1]
                        .replace(/['"]/g, '');
                }
            }

            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Download error:', error);
            toast.error('Download failed');
        } finally {
            setPaymentStatementLoader(false);
        }
    };

    const paidAmount = async (id) => {
        setPaymentStatementLoader(true);
        try {
            const result = await dispatch(markPaymentAsPaid(id));
            if (result.success) {
                toast.success(result.message);
                 dispatch(fetchPaymentStatements(1))
            } else {
                toast.error('Failed to mark payment as paid');
            }
        } catch (error) {
            toast.error('An error occurred');
        } finally {
            setPaymentStatementLoader(false);
        }
    }


    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {
        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchPaymentStatements(current_page, { sortBy: sortBy, sortDirection: dir, search: searchTerm, pageLength, ...filters }))
        }
        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                    </div>
                </th>
                <th>
                    <TableHeaderItem
                        title="Created By"
                        sortBy="name"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Paid At"
                        sortBy="paid_at"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Paid By"
                        sortBy="name"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Creation Date"
                        sortBy="created_at"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    Action
                </th>

            </tr>
        )
    }, [selectAll, searchTerm, sortConfig, current_page, selectedItems, filters, pageLength]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            payment?.map((item, index) => (
                <PaymentItems invoice={generatedInvoices} data={item} userToken={userToken} index={index} selectedItems={selectedItems} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} DownloadCsv={DownloadCsv} DownloadAttachedFile={DownloadAttachedFile} downloadLoader={downloadLoader} paidAmount={paidAmount} />
            ))
        )
    }, [payment, selectedItems]);

    //#endregion


    return (
        <>
            <div className="content" style={{ minHeight: 'auto' }}>
            <div className="row_main_head">
                <h2 className={`main_heading`}>Payments Statement</h2>
            </div>
            <ListLayout
                time={false}
                addButtonDisabled={true}
                disableBootstrap={true}
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                hideRemoveButton={true}
                paymentButton={true}
                totalPages={totalPages}
                fetchList={fetchPaymentStatements}
                selectedItems={selectedItems}
                refAddutton={refAddutton}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                loader={loader || paymentStatementLoader}
                noOfItems={total}
                containerStyle={{ marginTop: '0' }}
                searchPlaceholder="Search..."
                paginationParams={filters}
                defaultPageLength={pageLength}
                sortConfig={sortConfig}
            >
            </ListLayout>
            </div>
        </>
    )

}


const PaymentItems = ({
    data, index, current_page, pageLength, selectedItems, checkPermission, DownloadCsv, DownloadAttachedFile, downloadLoader, paidAmount
}) => {
    const serial = useMemo(() => {
        console.log('current_page', current_page, 'pageLength', pageLength, 'index', index);
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);

    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{serial}</span>
                </div>
            </td>
            <td>
                {data?.user?.name || 'N/A'}
            </td>
            <td>
                {data?.paid_at || 'N/A'}
            </td>
            <td>
                {data?.paid_by?.name || 'N/A'}
            </td>
            <td>
                {new Date(data?.created_at).toISOString().slice(0, 16).replace("T", " ")}
            </td>
            <td>
                <div className="d-flex flex-wrap justify-content-start gap-2">
                {!data?.paid_by &&
                    <SubmitButton btnText="Payment Sent" className="green" onClick={() => paidAmount(data.id)} />
                }
                <SubmitButton btnText="Download" onClick={() => DownloadCsv(data.id)} loader={downloadLoader} />
                {data?.attachment_path && data?.attachment_name && (
                    <SubmitButton btnText="Download Attached file" onClick={() => DownloadAttachedFile(data.id)} loader={downloadLoader} />
                )}
                </div>
            </td>
        </tr>
    )
}


export default IntepreterPaymentsStatement;